import React, { useState } from "react";
import TextBox from "devextreme-react/text-box";
import LVButtonAccion from "../../../Basicos/LVButtonAccion";
import { validarEMail } from "../../../../funciones/Varios";
import { function_ABM_EEX_ClientesPersonasRelevantes_Generar_JSON, function_ABM_EEX_ClientesPersonasRelevantes_Insertar, function_ABM_EEX_ClientesPersonasRelevantes_Modificar } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_ClientesPersonasRelevantes";

const LV_EEX_ClientesPersonasRelevantes = ({ index, datos, setDatos }) => {
  const [errores, setErrores] = useState({});

  const persona = datos.PersonasRelevantes?.[index];

  if (!persona) return null; // 🔐 Por si todavía no está la data

  const handleOnValueChanged = (campo, valor) => {
    const nuevasPersonas = [...datos.PersonasRelevantes];
    nuevasPersonas[index] = {
      ...nuevasPersonas[index],
      [campo]: valor
    };
    setDatos((prev) => ({
      ...prev,
      PersonasRelevantes: nuevasPersonas
    }));
  };

  const validar = () => {
    const nuevosErrores = {};
    if (!persona.Nombre) nuevosErrores.Nombre = "Campo requerido";
    if (!persona.Apellido) nuevosErrores.Apellido = "Campo requerido";
    if (!persona.Cargo) nuevosErrores.Cargo = "Campo requerido";
    if (!persona.Telefono) nuevosErrores.Telefono = "Campo requerido";
    if (!persona.Email) {
      nuevosErrores.Email = "Campo requerido";
    } else if (!validarEMail(persona.Email)) {
      nuevosErrores.Email = "Email inválido";
    }
    setErrores(nuevosErrores);
    return Object.keys(nuevosErrores).length === 0;
  };

  const handleOnClick_Guardar = async () => {
    if (!validar()) return;

    const personaJson = await function_ABM_EEX_ClientesPersonasRelevantes_Generar_JSON(datos.IdCliente,
      persona.Nombre, persona.Apellido, persona.Cargo, persona.Telefono, persona.Email)

    try {
      if (persona.IdCliente) {
        await function_ABM_EEX_ClientesPersonasRelevantes_Modificar(personaJson);
        alert("Persona modificada con éxito");
      } else {
        await function_ABM_EEX_ClientesPersonasRelevantes_Insertar(personaJson);
        alert("Persona guardada con éxito");
      }
    } catch (error) {
      alert("Error al guardar persona: " + error.message);
    }
  };

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
      <TextBox
        value={persona.Nombre}
        onValueChanged={(e) => handleOnValueChanged("Nombre", e.value)}
        placeholder="Nombre"
        width={200}
        isValid={!errores.Nombre}
        validationMessage={errores.Nombre}
      />
      <TextBox
        value={persona.Apellido}
        onValueChanged={(e) => handleOnValueChanged("Apellido", e.value)}
        placeholder="Apellido"
        width={200}
        isValid={!errores.Apellido}
        validationMessage={errores.Apellido}
      />
      <TextBox
        value={persona.Cargo}
        onValueChanged={(e) => handleOnValueChanged("Cargo", e.value)}
        placeholder="Cargo"
        width={200}
        isValid={!errores.Cargo}
        validationMessage={errores.Cargo}
      />
      <TextBox
        value={persona.Telefono}
        onValueChanged={(e) => handleOnValueChanged("Telefono", e.value)}
        placeholder="Teléfono"
        width={200}
        isValid={!errores.Telefono}
        validationMessage={errores.Telefono}
      />
      <TextBox
        value={persona.Email}
        onValueChanged={(e) => handleOnValueChanged("Email", e.value)}
        placeholder="E-Mail"
        width={200}
        isValid={!errores.Email}
        validationMessage={errores.Email}
      />

      <div style={{ marginTop: "10px" }}>
        <LVButtonAccion Texto={persona.IdCliente ? "MODIFICAR" : "GUARDAR"} onClick={handleOnClick_Guardar} />
      </div>
    </div>
  );
};

export default LV_EEX_ClientesPersonasRelevantes;
